#import "../fragments/calendar-sync.graphql"

query GetCalendarSync {
    loggedInUser {
        id
        calendarSync {
            ...CalendarSync
        }
        personalCalendarFeedUrl
        companyCalendarFeedUrl
    }
}
